<template>
  <v-container fluid style="padding: 0px;">
    <v-row style="padding: 0px;">
      <v-col cols="12" style="padding: 0px; position: relative;">
        <div ref="mapContainer" id="map"
          style="height: 93vh; overflow: hidden;"></div>
        <v-overlay v-if="loading" absolute :value="loading">
          <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <!-- KPIs de Alertas -->
        <div
          v-if="!loading && alertFilter.length > 0"
          class="map-kpi-wrapper"
        >
        <!-- Por Tipo -->
        <v-tooltip content-class="kpi-tooltip"
          v-for="kpi in alertKpis"
          :key="kpi.type"
          left
          :nudge-left="5"
          open-delay="150" close-delay="100"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              small
              class="kpi-btn"
              :class="{ active: selectedFilters.includes(changeSlugAlertType(kpi)) }"
              :style="{ backgroundColor: kpi.color }"
              v-bind="attrs"
              v-on="on"
              @click="toggleFilter(changeSlugAlertType(kpi));"
            >
              {{ kpi.count }}
            </v-btn>
          </template>

          <span>
            {{ changeSlugAlertType({ type: kpi.type }) }}: {{ kpi.count }}
          </span>
        </v-tooltip>
        </div>
        <!-- Botão para recentralizar o mapa -->
        <v-btn
          v-if="!loading"
          fab
          small
          color="white"
          elevation="2"
          style="position: absolute; bottom: 150px; right: 10px; z-index: 100;"
          @click="recenterMap"
          title="Centralizar mapa"
        >
          <v-icon color="#1D8AFF">mdi-crosshairs-gps</v-icon>
        </v-btn>
        
        <div v-if="!loading" style="position: absolute; top: 20px; left: 20px; z-index: 100; max-width: 400px; width: 100%;">
          <v-overlay v-show="selectedTab === 'historico' && loadingHistorical" absolute :value="loadingHistorical">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-overlay v-show="selectedTab === 'ativos' && loadingActive" absolute :value="loadingActive">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </v-overlay>
          <v-card max-height="90vh"
          :style="{ paddingBottom: !closeInfos ? '0' : '24px'}"
            style="border-radius: 20px; overflow-y: auto; background-color: rgba(255, 255, 255, 0.95); backdrop-filter: blur(10px)">
            <v-card-title style="justify-content: space-between;">
              <span v-if="selectedUnit">Alertas para {{ selectedUnit.name }}</span>
              <span v-else>Últimos Alertas</span>

              <img
                @click="closeInfos = !closeInfos"
                :src="chevronDown"
                alt="chevron down"
                class="close-alerts"
                :class="{ 'flipped': !closeInfos }"
                style="cursor: pointer;"
              />
            </v-card-title>
            <div v-if="closeInfos">
              <div class="tab-selector">
                <button
                  :class="{'active-tab': selectedTab === 'ativos'}"
                  @click="selectedTab = 'ativos'"
                >
                  Ativos
                </button>
                <button
                  :class="{'active-tab': selectedTab === 'historico'}"
                  @click="selectedTab = 'historico'"
                >
                  Histórico
                </button>
              </div>
              <div          
                style="display: flex; align-items: center;justify-content: space-between;padding: 0px 16px 16px;gap: 8px; cursor: pointer;width: 100%;"
                class="filter-header"
                :class="{ 'active': selectedFilters.length > 0 }"
              >
              <div @click="toggleFilterSection"  style="display: flex; align-items: center;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16" fill="none">
                  <mask id="mask0_2275_3694" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_2275_3694)">
                    <path d="M7.01923 11.2667C6.77991 11.2667 6.5859 11.0727 6.5859 10.8333C6.5859 10.594 6.77991 10.4 7.01923 10.4H8.9744C9.21372 10.4 9.40773 10.594 9.40773 10.8333C9.40773 11.0727 9.21372 11.2667 8.9744 11.2667H7.01923ZM4.70273 8.43334C4.46341 8.43334 4.2694 8.23933 4.2694 8C4.2694 7.76068 4.46341 7.56667 4.70273 7.56667H11.2911C11.5304 7.56667 11.7244 7.76068 11.7244 8C11.7244 8.23933 11.5304 8.43334 11.2911 8.43334H4.70273ZM3.16673 5.6C2.92741 5.6 2.7334 5.40599 2.7334 5.16667C2.7334 4.92735 2.92741 4.73334 3.16673 4.73334H12.8334C13.0727 4.73334 13.2667 4.92735 13.2667 5.16667C13.2667 5.40599 13.0727 5.6 12.8334 5.6H3.16673Z" :fill="selectedFilters.length > 0 ? '#1D8AFF' : '#666'"/>
                  </g>
                </svg>
                <span :style="{ color: selectedFilters.length > 0 ? '#1D8AFF' : '#666' }">Filtros</span>
              </div>
              <!-- <div>
                <span>Total: {{ alertFilter.length }}</span>
              </div> -->
                <div
                     @click="openArchiveDialogByArchiveAll(alertFilter)"
                      class="archive-button"
                      style="margin-top: 0px;"
                    >
                      Arquivar todos
                    </div>
              </div>
              <div v-if="showFilterSection" style="padding: 0px 16px 16px 16px;">
                  <div style="display: flex; flex-wrap: wrap; gap: 8px;">
                    <div 
                      v-for="option in alertTypeOptions" 
                      :key="option"
                      @click="toggleFilter(option)"
                      class="filter-tag"
                      :class="{ 'active': selectedFilters.includes(option) }"
                    >
                      <span>{{ option }}</span>
                      <span v-if="selectedFilters.includes(option)" class="remove-icon">×</span>
                    </div>
                  </div>
                </div>
  

              <v-list :style="{ overflowY: 'auto', height: !showFilterSection ? '65vh' : '50vh', position: 'relative' }">
                <div v-if="alertFilter.length == 0" style="text-align: center;font-weight: 600;font-size: 16px;">Nenhum alerta encontrado</div>
                <v-list-item
                  v-for="(alert, index) in alertFilter"
                  :key="`${selectedTab}-${alert.id || alert.doc_id}-${index}`"
                  style="padding: 4px; position: relative;"
                >
                  <v-list-item-content style="border: 1px solid #DBDBDB;border-radius: 12px;padding: 12px;">
                    <div style="justify-content: space-between;display: flex;align-items: center; gap: 8px;">
                      <span :style="{backgroundColor: getAlertBackgroundColor(alert.type)}" 
                        style="border-radius: 16px;padding:4px;font-weight: 300;font-size: 14px;color: white;">
                        {{changeSlugAlertType(alert)}}
                      </span>
                      <div style="display: flex; align-items: center; gap: 4px; margin-left: auto;">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              small
                              v-bind="attrs"
                              v-on="on"
                              @click.stop="focusUnitFromAlert(alert)"
                              :class="['center-map-btn', { 'center-map-btn--active': isAlertUnitSelected(alert) }]"
                            >
                              <v-icon :color="isAlertUnitSelected(alert) ? '#FFFFFF' : '#1D8AFF'">
                                mdi-crosshairs-gps
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ isAlertUnitSelected(alert) ? 'Alerta centralizado' : 'Centralizar no mapa' }}</span>
                        </v-tooltip>
                        <img
                          v-if="alert.type !== 'lack_of_signal' && alert.type !== 'no_variation' && alert.type !== 'no_communication' && alert.type !== 'water_probe_sensor_error'"
                          @click="toggleAlertDetails(alert.id)"
                          :src="chevronDown"
                          alt="chevron down"
                          class="open-alerts-details"
                          :class="{ 'flipped': !isAlertDetailsOpen(alert.id) }"
                          style="cursor: pointer;"
                        />
                      </div>
                    </div>
                      <div v-if="isAlertDetailsOpen(alert.id) && (alert.type === 'consumption' || alert.type === 'goal_scheduled' || alert.type === 'goal_exceeded')" class="alert-details-card">
                        <div class="details-content">
                          <div v-if="alert.type === 'consumption'" class="detail-row">
                            <span class="detail-label">Tipo: </span>
                            <span class="detail-value">{{ getConsumptionType(alert) }}</span>
                          </div>
                          <div class="detail-row">
                            <span class="detail-label">{{ getConsumptionLabel(alert, "alertLimit") }}:</span>
                            <span class="detail-value">{{ calculateConsumptionAlert(alert, "limit") }} {{ measureUnit }}</span>
                          </div>
                          <div class="detail-row">
                            <span class="detail-label">{{ getConsumptionLabel(alert, "exceededAmount") }}:</span>
                            <span class="detail-value">{{ calculateConsumptionAlert(alert, "exceeded") }} {{ measureUnit }} </span>
                          </div>
                          <div class="detail-divider"></div>
                          <div class="detail-row">
                            <span class="detail-label">{{ getConsumptionLabel(alert, "consumedAmount") }}:</span>
                            <span class="detail-value">{{ calculateConsumptionAlert(alert, "consumed") }} {{ measureUnit }}</span>
                          </div>
                        </div>
                      </div>
                      <div v-if="isAlertDetailsOpen(alert.id) && (alert.type === 'water_probe_base_maximum_level' || alert.type === 'water_probe_base_minimum_level')" class="alert-details-card">
                        <div class="details-content">
                          <div class="detail-row">
                            <span class="detail-label">Nível (M):</span>
                            <span class="detail-value">{{ alert.waterHeight }} M</span>
                          </div>
                          <div class="detail-row">
                            <span class="detail-label">Nível (%):</span>
                            <span class="detail-value">{{ getLevelPercentage(alert).toFixed(2)}} %</span>
                          </div>
                          <div class="detail-divider"></div>
                          <div class="detail-row">
                            <span class="detail-label">Capacidade disponível:</span>
                            <span class="detail-value">{{ formatNumberMeasure((getAvailableCapacity(alert)))}} {{ measureUnit }}</span>
                          </div>
                          <div class="detail-row">
                            <span class="detail-label">Capacidade total:</span>
                            <span class="detail-value">{{ formatNumberMeasure((getMaxCapacity(alert)))}} {{ measureUnit }}</span>
                          </div>
                          
                        </div>
                      </div>
                      <div v-if="isAlertDetailsOpen(alert.id) && (alert.type === 'low_battery')" class="alert-details-card">
                        <div class="details-content">
                          <div class="detail-row">
                            <span class="detail-label">Nível da bateria:</span>
                            <span class="detail-value">{{ alert.percentage }} %</span>
                          </div>
                        </div>
                      </div>
                    <div style="font-weight: 300;font-size: 12px;" :style="{marginTop: isAlertDetailsOpen(alert.id) ? '16px' : '0px'}">{{ formatDate(alert.date_of_occurrence) }}</div>
                    <div v-if="!selectedUnit" style="margin-top: 12px;"><strong>{{ alert.unitName || getUnitName(alert.id_unit) }}</strong></div>
                    <div v-if="!selectedUnit" style="font-weight: 300;font-size: 12px;">{{ alert.address }}</div>
                    <div v-if="selectedTab === 'ativos'"
                      @click="openArchiveDialog([alert])"
                      class="archive-button"
                    >
                      Arquivar alerta
                    </div>
                    <div v-else-if="selectedTab === 'historico'" style="background: #f5f5f5; border-radius: 8px; padding: 4px 12px; font-size: 13px; color: #444; font-weight: 400; margin-top: 8px;">
                      Arquivado por <b>{{ alert.archivedInfos && alert.archivedInfos.nameUser ? alert.archivedInfos.nameUser : 'sem usuário específico' }}</b>
                      em <b>{{ alert.archivedInfos && alert.archivedInfos.archivedDate ? formatDate(alert.archivedInfos.archivedDate) : 'sem data específica' }}</b>
                      Observação: <b style="white-space: pre-wrap; overflow-wrap: break-word; word-break: break-word;">{{ alert.archivedInfos && alert.archivedInfos.observation ? alert.archivedInfos.observation : 'não especificada' }}</b>
                    </div>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card v-if="selectedAlert" class="pa-4">
        <v-card-title class="headline">
          {{ selectedAlert.alertName }}
        </v-card-title>

        <v-card-text>
          <!-- Seção para informações principais -->
          <v-row>
            <v-col cols="12" md="12">
              <div class="d-flex align-center">
                <v-icon class="mr-2">mdi-home-city</v-icon>
                <strong>Unidade:</strong>
                <span class="ml-2">{{ selectedAlert.unitName }}</span>
              </div>
            </v-col>

            <v-col cols="12" md="12">
              <div class="d-flex align-center">
                <v-icon class="mr-2">mdi-calendar</v-icon>
                <strong>Data de Ocorrência:</strong>
                <span class="ml-2">{{ formatDate(selectedAlert.date_of_occurrence) }}</span>
              </div>
            </v-col>
          </v-row>

          <!-- Seção para tipo de alerta -->
          <v-divider class="my-4"></v-divider>
          <v-row>
            <v-col cols="12" md="12">
              <div class="d-flex align-center">
                <v-icon class="mr-2" >mdi-alert-circle</v-icon>
                <strong>Tipo: </strong>
                <span class="ml-2">{{ changeSlugAlertType(selectedAlert) }}</span>
              </div>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>

    </v-dialog>
    <v-dialog v-model="archiveObservationDialog" max-width="400px" style="z-index: 1000;">
      <v-card class="pa-4">
        <v-card-title class="headline">Observação de Arquivamento</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="archiveObservationText"
            label="Digite uma observação (opcional)"
            rows="3"
            :counter="200"
            maxlength="200"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="archiveObservationDialog = false">Cancelar</v-btn>
          <v-btn color="#1D8AFF" @click="confirmArchiveObservation">Confirmar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog de confirmação para arquivar alerta -->
    <v-dialog v-model="archiveDialog" max-width="400px" style="z-index: 1000;">
      <v-card class="pa-4">
        <v-card-title class="d-flex justify-space-between align-center pa-0 mb-4">
          <span class="text-h6 font-weight-bold">Arquivar Alerta</span>
          <v-btn icon @click="archiveDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        
        <v-card-text class="pa-0 mb-4">
          <div class="text-center mb-4">
            <div class="archive-icon-container">
              <v-icon size="48" color="#1D8AFF">mdi-archive-arrow-down</v-icon>
            </div>
          </div>
          
          <div class="text-center">
            <h3 class="text-h6 font-weight-bold mb-2">Tem certeza que deseja arquivar este alerta?</h3>
            <p class="text-body-2 text-medium-emphasis">
              Após arquivado, ele não aparecerá mais na visualização principal, mas ainda ficará acessível no histórico.
            </p>
          </div>
        </v-card-text>

        <v-card-actions class="pa-0" style="justify-content: center;display: flex;">
          <v-btn 
            style="min-width: 45%; border: 1px solid #DBDBDB"
            @click="archiveDialog = false"
            class="mr-2"
          >
            Cancelar
          </v-btn>
          <v-btn 
            style="min-width: 45%;"
            color="#1D8AFF" 
            @click="confirmArchive"
            class="mr-2"
          >
            Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Toast de notificação de arquivamento -->
    <div v-if="showArchiveToast" class="custom-toast">
      <div class="toast-content">
        <div class="d-flex align-center">
          <div class="success-icon-container mr-3">
            <v-icon color="white" size="20">mdi-check</v-icon>
          </div>
          <span class="text-body-1 font-weight-medium" style="color: #333;">
            Alerta arquivado no histórico
          </span>
        </div>
        <div class="d-flex align-center">
          <v-btn
            text
            small
            @click="undoArchive"
            style="color: #666; border: 1px solid #DBDBDB; margin-right: 8px;"
          >
            Desfazer
          </v-btn>
          <v-btn
            icon
            small
            @click="closeToast"
            style="color: #666;"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import AlertsNotificationsService from "@/services/server/AlertsNotificationService";
import UnitsServiceServer from "@/services/server/UnitsService";
import DashboardService from "@/services/server/DashboardService.js";
import { mapGetters } from 'vuex';
import chevronDown from '@/assets/dashboard/chevron-down.png';
import AlertsService from "@/services/firebase/Alerts/AlertsService";
import { showErrorSnackBar, showSuccessSnackBar, showInfoSnackBar } from "@/utils/SnackBartHelper";
import SectorsService from "../../services/firebase/Sectors/SectorsService";

export default {
  name: 'ChooseAlerts',
  data() {
    return {
      center: { lat: -8.037114010212356, lng: -35.100027202099725 },
      units: [],
      selectedUnit: null,
      alerts: [],
      selectedType: null,
      listAlertTypes: ["consumption", "lack_of_signal", "no_variation", "low_battery",
        "no_communication", "goal_scheduled", "goal_exceeded", "water_probe_base_minimum_level", 
        "water_probe_base_maximum_level", "water_probe_sensor_error"],
      showSelect: false,
      loading: true,
      selectedAlert: null,
      dialog: false,
      map: null,
      unitMarkers: [], 
      alertMarkers: [], 
      alertTypeOptions: [
        "Consumo",
        "Falta de sinal",
        "Sem variação",
        "Bateria baixa",
        "Sem comunicação",
        "Ponto da Meta",
        "Meta Ultrapassada",
        "Nível mínimo",
        "Nível máximo",
        "Sonda desconectada"
      ],
      currentFilter: null,
      selectedUnits: [],
      chevronDown,
      closeInfos: true,
      selectedFilters: [],
      showFilterSection: false,
      archiveDialog: false,
      alertToArchive: null,
      showArchiveToast: false,
      archivedAlerts: [],
      archiveTimer: null,
      selectedTab: 'ativos',
      historicalAlerts: [], 
      loadingActive: false,
      loadingHistorical: false,
      openAlertDetails: [],
      measureUnit:null,
      hasShownMarkerColorNotice: false,
      archiveObservationDialog: false,
      archiveObservationText: null,
      sectorsByModem: new Map(),
      alertConsumptionLabels: {
        alertLimit: "Limite do alerta", 
        exceededAmount: "Quantidade excedida", 
        consumedAmount: "Quantidade consumida", 
        minConsumption: "Consumo mínimo", 
        remainingConsumption: "Consumo restante"
      }
    };
  },
  computed: {
    ...mapGetters([
      'getSelectedUnits', 'getCurrentUserName'
    ]),
    unitMeasureVuex() {
      return this.$store.getters.unitMeasure;
    },
    selectedPeriodValueVuex() {
      return this.$store.getters.selectedPeriodValue;
    },
    unitsWithAlerts() {
      return this.units.filter(unit => unit.alerts.length > 0);
    },
    sortedAlerts() {
      return this.alerts.sort((a, b) => b.date_of_occurrence._seconds - a.date_of_occurrence._seconds);
    },
    alertsForCurrentTab() {
      return this.selectedTab === 'historico' ? this.historicalAlerts : this.alerts;
    },
    alertsForSelectedUnits() {
      if (!this.selectedUnits || this.selectedUnits.length === 0) {
        return this.alertsForCurrentTab;
      }

      const selectedIds = this.selectedUnits.map(unit => String(unit.id));
      return this.alertsForCurrentTab.filter(alert => selectedIds.includes(String(alert.id_unit)));
    },
    activeAlertsForSelectedUnits() {
      if (!this.selectedUnits || this.selectedUnits.length === 0) {
        return this.alerts;
      }

      const selectedIds = this.selectedUnits.map(unit => String(unit.id));
      return this.alerts.filter(alert => selectedIds.includes(String(alert.id_unit)));
    },
    visibleAlerts() {
      let items = this.alertsForSelectedUnits;

      if (this.selectedFilters.length > 0) {
        const selectedTypes = this.selectedFilters.map(filter => this.changeAlertType(filter));
        items = items.filter(alert => selectedTypes.includes(alert.type));
      }

      return items.slice().sort((a, b) => {
        const getSeconds = (d) => {
          if (!d) return 0;
          if (typeof d === 'object' && d.seconds !== undefined) return d.seconds;
          if (typeof d === 'object' && d._seconds !== undefined) return d._seconds;
          try { return Math.floor(new Date(d).getTime() / 1000); } catch { return 0; }
        };

        return getSeconds(b.date_of_occurrence) - getSeconds(a.date_of_occurrence);
      });
    },
    visibleMapAlerts() {
      if (this.selectedFilters.length === 0) {
        return this.activeAlertsForSelectedUnits;
      }

      const selectedTypes = this.selectedFilters.map(filter => this.changeAlertType(filter));
      return this.activeAlertsForSelectedUnits.filter(alert => selectedTypes.includes(alert.type));
    },
    alertFilter() {
      return this.visibleAlerts
    },
    alertKpis() {
      if (!this.alertsForSelectedUnits || this.alertsForSelectedUnits.length === 0) return [];
      
      const counts = {};
      this.alertsForSelectedUnits.forEach(alert => {
        const type = alert.type;
        if (!counts[type]) {
          counts[type] = 0;
        }
        counts[type]++;
      });
      
      const kpis = Object.keys(counts).map(type => {
        return {
          type: type,
          count: counts[type],
          color: this.getColorByAlertType(type) || '#757575'
        };
      });
      
      kpis.sort((a, b) => b.count - a.count);
      
      return kpis;
    },
  },
  methods: {
    getConsumptionLabel(alert, labelKey) {
      const type = alert.comparisonType;

      if (type === "LESS_THAN") {
        if (labelKey === "alertLimit") return this.alertConsumptionLabels.minConsumption;
        if (labelKey === "exceededAmount") return this.alertConsumptionLabels.remainingConsumption;
      }

      return this.alertConsumptionLabels[labelKey] ?? '';
    },

    calculateConsumptionAlert(alert, context) {
      const type = this.checkComparisonType(alert);
      switch (context) {
        case "limit":
          if (type === "LESS_THAN") {
            return this.formatNumberMeasure((alert.liters_consumed_in_period || 0) + (alert.liters_exceeded_in_period || 0))
          }
          return this.formatNumberMeasure((alert.liters_consumed_in_period || 0) - (alert.liters_exceeded_in_period || 0));

        case "exceeded":
          return this.formatNumberMeasure(alert.liters_exceeded_in_period || 0);

        case "consumed":
          return this.formatNumberMeasure(alert.liters_consumed_in_period || 0);

        default:
          return 0;
      }
    },

    checkComparisonType(alert) {
      return alert?.comparisonType || null;
    },

    getConsumptionType(alert) {
      const type = this.checkComparisonType(alert);
      switch (type) {
        case "GREATER_THAN": return "Consumo máximo excedido";
        case "LESS_THAN": return "Consumo mínimo não atingido";
        default: return "Consumo máximo excedido";
      }
    },
    
    // Função auxiliar privada — evita repetição do .get()
    getSectorByModemId(modemId) {
      return this.sectorsByModem.get(modemId) ?? null;
    },

    getLevelPercentage(alert) {
      const sector = this.getSectorByModemId(alert.modem_id);
      if (!sector) return 0;

      const waterHeight = parseFloat(alert.waterHeight);
      const maxHeight = parseFloat(sector.reservoirMaxHeight);

      if (!maxHeight) return 0; // evita divisão por zero

      return (waterHeight / maxHeight) * 100;
    },

    getAvailableCapacity(alert) {
      const sector = this.getSectorByModemId(alert.modem_id);
      if (!sector) return 0;

      const maxCapacity = parseFloat(sector.reservoirVolume);
      const levelPercentage = this.getLevelPercentage(alert);

      const currentVolume = (levelPercentage / 100) * maxCapacity;

      return currentVolume; 
    },

    getMaxCapacity(alert) {
      const sector = this.getSectorByModemId(alert.modem_id);
      if (!sector) return 0;

      return parseFloat(sector.reservoirVolume);
    },

    /**
     * Normaliza startDate para início do dia e endDate para fim do dia (horário local),
     * para que o payload no filter tenha o intervalo correto ao ser serializado para ISO.
     */
    normalizePeriodDatesForFilter(periodValue) {
      if (!periodValue || periodValue.startDate == null || periodValue.endDate == null) return periodValue;
      const start = periodValue.startDate;
      const end = periodValue.endDate;
      if (!(start instanceof Date) || !(end instanceof Date) || isNaN(start) || isNaN(end)) return periodValue;
      return {
        ...periodValue,
        startDate: new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0, 0),
        endDate: new Date(end.getFullYear(), end.getMonth(), end.getDate(), 23, 59, 59, 999)
      };
    },

    /**
     * Retorna o objeto de data para os filtros da API.
     * No período estimado, se startDate/endDate estiverem null (ex.: TopBar usa getSelectedUnit e na página de alertas usamos getSelectedUnits),
     * calcula as datas a partir da primeira unidade selecionada.
     */
    getDateFilterForAlerts() {
      const periodValue = this.selectedPeriodValueVuex;
      if (!periodValue || periodValue.period == null) return periodValue;

      const { period, startDate, endDate } = periodValue;
      const needEstimedDates = period === 'estimed' && (startDate == null || endDate == null);

      if (!needEstimedDates) {
        return this.normalizePeriodDatesForFilter(periodValue);
      }

      const firstSelected = (this.getSelectedUnits && this.getSelectedUnits[0]) || (this.selectedUnits && this.selectedUnits[0]);
      if (!firstSelected) return periodValue;

      const unit = this.units.find(u => u.id === firstSelected.id) || firstSelected;
      const today = new Date();

      if (unit.estimateEndDate) {
        const start = unit.estimateStartDate ? new Date(unit.estimateStartDate) : null;
        const end = unit.estimateEndDate ? new Date(unit.estimateEndDate) : null;
        return this.normalizePeriodDatesForFilter({ period, startDate: start || startDate, endDate: end || endDate });
      }
      if (unit.unit && unit.unit.lastReadingDate != null && unit.unit.lastScheduledReadingDate != null) {
        const lr = unit.unit.lastReadingDate;
        const ls = unit.unit.lastScheduledReadingDate;
        const lastReadingDate = new Date((lr._seconds || lr.seconds) * 1000 + ((lr._nanoseconds != null ? lr._nanoseconds : lr.nanoseconds) || 0) / 1e6);
        let previewDate = new Date(lastReadingDate);
        while (previewDate <= today) {
          previewDate.setMonth(previewDate.getMonth() + 1);
        }
        const previewDateCurrent = new Date(previewDate);
        previewDateCurrent.setMonth(previewDate.getMonth() - 1);
        return this.normalizePeriodDatesForFilter({ period, startDate: previewDateCurrent, endDate: previewDate });
      }
      return periodValue;
    },

    closeAllTooltips() {
      const closeTooltip = (markers) => {
        markers.forEach(({ marker}) => {
          if (marker.__infoWindow) {
            marker.__setOpenedByClick(false);
            marker.__infoWindow.close();
          }
        });
      };

      closeTooltip(this.unitMarkers);
      closeTooltip(this.alertMarkers);
    },

    /** Sincroniza selectedUnits com o Vuex (ex.: ao entrar na página com unidade já selecionada). */
    syncSelectedUnitsFromVuex() {
      const fromVuex = this.getSelectedUnits;
      if (Array.isArray(fromVuex) && fromVuex.length > 0) {
        this.selectedUnits = [...fromVuex];
      }
    },

    async focusUnitFromAlert(alert) {
      if (!alert || !alert.id_unit) return;

      // Garante que selectedUnits está em sync com Vuex antes de decidir (ex.: unidade pré-selecionada na sidebar)
      this.syncSelectedUnitsFromVuex();

      const unitId = alert.id_unit;
      const currentSelected = Array.isArray(this.selectedUnits) ? this.selectedUnits : [];

      const isUnitAlreadySelected = currentSelected.some(u => String(u.id) === String(unitId));

      // remover centralização: unidade já está na seleção (sozinha ou com outras)
      if (isUnitAlreadySelected) {
        this.closeAllTooltips();
        const newSelection = currentSelected.filter(u => String(u.id) !== String(unitId));
        this.selectedUnits = newSelection;
        this.$store.commit('SET_SELECTED_UNITS', newSelection);
        if (newSelection.length === 0) {
          this.$store.commit('SET_SELECTED_UNIT', null);
          // Recarregar todos os marcadores (fetchMarks filtra por selectedUnits; com [] traz todas as unidades) e recentrar
          await this.fetchMarks();
          if (this.selectedTab === 'historico') {
            this.fetchHistoricalAlerts();
          } else {
            this.fetchActiveAlerts();
          }
        } else {
          this.updateMarkersForSelectedUnits();
        }
        return;
      }

      // centralizar: selecionar esta unidade e centralizar mapa
      this.closeAllTooltips();

      // Tenta reaproveitar objeto da lista de unidades conhecidas; se não achar, usa stub com id
      const unitForSelection =
        (this.units || []).find(u => String(u.id) === String(unitId)) ||
        currentSelected.find(u => String(u.id) === String(unitId)) ||
        { id: unitId };

      this.selectedUnits = [unitForSelection];
      this.$store.commit('SET_SELECTED_UNITS', [unitForSelection]);
      this.updateMarkersForSelectedUnits();
      this.newCenterMapOnSelectedUnit({ id: unitId });

      this.$nextTick(() => {
        const entry = this.unitMarkers.find(m => String(m.id) === String(unitId));
        if (entry && entry.marker.__infoWindow) {
          entry.marker.__setOpenedByClick(true);
          entry.marker.__infoWindow.open({
            anchor: entry.marker,
            map: this.map
          });
        }
      });
    },

    /** Para o ícone de mira mostrar "ativo": considera Vuex (unidade pré-selecionada) ou local. */
    isAlertUnitSelected(alert) {
      if (!alert || !alert.id_unit) return false;
      const fromVuex = this.getSelectedUnits;
      const list = (Array.isArray(fromVuex) && fromVuex.length > 0) ? fromVuex : (this.selectedUnits || []);
      if (!Array.isArray(list) || list.length === 0) return false;

      return list.some(u => String(u.id) === String(alert.id_unit));
    },
    formatNumberMeasure(value){
      if (value === null || value === undefined || isNaN(value)) {
        return '0,00';
      }
      value = Number(value)
      if(this.unitMeasureVuex === "liters"){
        this.measureUnit = "L"
        return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }else if(this.unitMeasureVuex === "m3"){
        this.measureUnit = "M³"
        return (value/1000).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      }
    },
    
    toggleSelectVisibility() {
      this.showSelect = !this.showSelect;
    },
    getUnitName(unitId) {
      const unit = this.units.find(unit => unit.id === unitId);
      return unit ? unit.name : 'Desconhecido';
    },
    changeSlugAlertType(selectedAlert) {
      switch (selectedAlert.type) {
        case "consumption":
          return "Consumo"
        case "lack_of_signal":
          return "Falta de sinal"
        case "no_variation":
          return "Sem variação"
        case "low_battery":
          return "Bateria baixa"
        case "no_communication":
          return "Sem comunicação"
        case "goal_scheduled":
          return "Ponto da Meta"
        case "goal_exceeded":
          return "Meta Ultrapassada"
        case "water_probe_base_minimum_level":
          return "Nível mínimo"
        case "water_probe_base_maximum_level":
          return "Nível máximo"
        case "water_probe_sensor_error":
          return "Sonda desconectada"
        default:
          return "Indefinido"
      }
    },
    changeAlertType(selectedAlert) {
      switch (selectedAlert) {
        case "Consumo":
          return "consumption"
        case "Falta de sinal":
          return "lack_of_signal"
        case "Sem variação":
          return "no_variation"
        case "Bateria baixa":
          return "low_battery"
        case "Sem comunicação":
          return "no_communication"
        case "Ponto da Meta":
          return "goal_scheduled"
        case "Meta Ultrapassada":
          return "goal_exceeded"
        case "Nível mínimo":
          return "water_probe_base_minimum_level"
        case "Nível máximo":
          return "water_probe_base_maximum_level"
        case "Sonda desconectada":
          return "water_probe_sensor_error"
        default:
          return "undefined"
      }
    },
    navigateTo(route) {
      this.$router.push(route);
    },
    getColorByAlertType(alertType){
      switch (alertType) {
        case "consumption":
          return "#FF9800";
        case "lack_of_signal":
          return "#F44336";
        case "no_variation":
          return "#4CAF50";
        case "low_battery":
          return "#9C27B0";
        case "no_communication":
          return "#2196F3";
        case "goal_scheduled":
          return "#FFC107";
        case "goal_exceeded":
          return "#D32F2F";
        case "water_probe_base_minimum_level":
          return "#8D6F64";
        case "water_probe_base_maximum_level":
          return "#EFC3CA";
        case "water_probe_sensor_error":
          return "#460202";
        case "other":
          return "#757575";
        default:
          return "#1D8AFF";
      }
    },
    recenterMap() {
      this.calculateInitialMapCenter();
    },
    calculateInitialMapCenter() {
      if (!this.map) return;

      // Coleta TODOS os marcadores (unitMarkers + alertMarkers)
      const allMarkers = [];
      
      // Adiciona os marcadores de unidades
      if (this.unitMarkers && this.unitMarkers.length > 0) {
        this.unitMarkers.forEach(({ marker }) => {
          if (marker && marker.position && marker.map) {
            allMarkers.push(marker);
          }
        });
      }

      // Adiciona os marcadores de alertas
      if (this.alertMarkers && this.alertMarkers.length > 0) {
        this.alertMarkers.forEach(({ marker }) => {
          if (marker && marker.position && marker.map) {
            allMarkers.push(marker);
          }
        });
      }

      if (allMarkers.length === 0) {
        return;
      }

      // Caso simples: 1 marcador
      if (allMarkers.length === 1) {
        const position = allMarkers[0].position;
        const singlePoint = {
          lat: typeof position.lat === 'function' ? position.lat() : position.lat,
          lng: typeof position.lng === 'function' ? position.lng() : position.lng
        };
        
        this.center = singlePoint;
        this.map.panTo(singlePoint);
        this.map.setZoom(15);
        return;
      }

      // Múltiplos marcadores: usa LatLngBounds para ajuste automático
      const bounds = new google.maps.LatLngBounds();
      
      allMarkers.forEach(marker => {
        const position = marker.position;
        const lat = typeof position.lat === 'function' ? position.lat() : position.lat;
        const lng = typeof position.lng === 'function' ? position.lng() : position.lng;
        if (lat == null || lng == null) return; // sanitização de coordenadas inválidas

        bounds.extend(new google.maps.LatLng(lat, lng));
      });

      // Calcula o centro do bounding box
      const center = bounds.getCenter();
      this.center = {
        lat: center.lat(),
        lng: center.lng()
      };

      // fitBounds ajusta automaticamente o zoom e centro para mostrar todos os pontos
      this.map.fitBounds(bounds, {
        top: 80,    // Padding superior (evita que fique atrás do card de alertas)
        right: 50,  // Padding direito
        bottom: 50, // Padding inferior
        left: 50    // Padding esquerdo
      });
    },


    async fetchMarks() {
      this.loading = true;
      try {
        const unitsResponse = await UnitsServiceServer.findAllFranchisee();
        let unitsMarkers = unitsResponse.data.data;
        const response = await AlertsNotificationsService.mapFindAll();
        let unitsWithAlerts = response.data;

        /* if (this.selectedUnits && this.selectedUnits.length > 0) {
          const selectedUnitIds = this.selectedUnits.map(unit => unit.id);
          unitsMarkers = unitsMarkers.filter(unit => selectedUnitIds.includes(unit.id));
          unitsWithAlerts = unitsWithAlerts.filter(unit => selectedUnitIds.includes(unit.id));
        } */

        this.clearAllMarkers();
        // Busca as cores dos marcadores em lote
        const markerColors = await this.getAllMarkerColors(unitsMarkers, unitsWithAlerts);

        // Cria os marcadores de unidade
        this.unitMarkers = unitsMarkers.map(unit => {
          const markerElement = new google.maps.marker.AdvancedMarkerElement({
            position: {
              lat: Number(unit.address.lat) || 0,
              lng: Number(unit.address.lng) || 0 
            },
            map: this.map,
            content: this.createMarkerElement(markerColors[unit.id] || '#1D8AFF')
          });
          this.attachMarkerTooltip(markerElement, unit);
          
          return { id: unit.id, marker: markerElement };
        });

        const updatedUnitsWithAlerts = unitsMarkers
        .filter(unit => unitsWithAlerts.some(u => u.id === unit.id))
        .map(unit => {
          const alertUnit = unitsWithAlerts.find(u => u.id === unit.id) || {};
          return {
            ...alertUnit,
            name_client: unit.name_client,
            matricula: unit.matricula,
            franchiseeName: unit.franchiseeName,
            tarrifsTypes: {
              sewer: {
                tariffType: unit.tarrifsTypes.sewer.tariffType,
                value: unit.tarrifsTypes.sewer.value
              },
              water: {
                tariffType: unit.tarrifsTypes.water.tariffType,
                value: unit.tarrifsTypes.water.value
              }
            }
          };
        });

        this.units = updatedUnitsWithAlerts
        this.alerts = unitsWithAlerts.flatMap(unit => {
          const markerUnit = unitsMarkers.find(m => m.id === unit.id);
          const unitName = unit.name || (markerUnit && markerUnit.name) || '';
          const address = unit.address || (unit.position && unit.position.address) || (markerUnit && markerUnit.address) || '';
          return (unit.alerts || []).map(alert => ({
            ...alert,
            id_unit: unit.id,
            unitName,
            address
          }));
        }).sort((a, b) => b.date_of_occurrence._seconds - a.date_of_occurrence._seconds);
        this.currentFilter = null;

        // Cria os marcadores de alerta (usando a mesma cor do markerColors)
        this.alertMarkers = this.units.flatMap(unit => {
          if (!unit.alerts) return [];
          return unit.alerts.map(alert => {
            const alertElement = new google.maps.marker.AdvancedMarkerElement({
              position: {
                lat: unit.position.lat || 0,
                lng: unit.position.lng || 0 
              },
              map: this.map,
              content: this.createAlertElement(markerColors[unit.id] || '#1D8AFF')
            });
            this.attachMarkerTooltip(alertElement, unit);
            return { id: alert.id || alert.doc_id, marker: alertElement };
          });
        });
        await this.$nextTick();
        this.syncMapMarkersVisibility();
        this.calculateInitialMapCenter();
      } catch (error) {
        console.warn(error);
      } finally {
        this.loading = false;
      }
    },
    async getAllMarkerColors(units, unitsWithAlert) {
      if (!units || units.length === 0) {
        return {};
      }
      const colorMap = {};

      units.forEach(unit => {
        // encontra a unidade correspondente dentro de unitsWithAlert
        const unitWithAlert = unitsWithAlert.find(u => u.id === unit.id);
        // pega alerta
        let alertType = unitWithAlert && unitWithAlert.alerts.length > 0
          ? unitWithAlert.alerts[0].type
          : null;
        if(!this.listAlertTypes.includes(alertType) && alertType !== null){
          alertType = "other";
        }
        // define cor com base no tipo do alerta
        colorMap[unit.id] = this.getColorByAlertType(alertType);
      });
      
      return colorMap;
    },
    async initMap() {
      await this.$gmapApiPromiseLazy()
      this.map = new google.maps.Map(this.$refs.mapContainer, {
        center: this.center,
        zoom: 10,
        minZoom: 2,
        maxZoom: 17,
        mapTypeControl: true,
        mapTypeControlOptions: {
          style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          position: google.maps.ControlPosition.TOP_RIGHT,
        },
        mapId: 'map'
      });
      await this.fetchMarks();
      this.applyUnitFiltering();


      //condicional para verificar se existe unidade(s) selecionadas e centralizar na última
      if (this.selectedUnits.length > 0) {
        this.newCenterMapOnSelectedUnit(this.selectedUnits[this.selectedUnits.length - 1]);
      }

      // Ao entrar na tela: buscar alertas conforme unidades selecionadas (ou todos) e período
      if (this.selectedTab === 'historico') {
        this.fetchHistoricalAlerts();
      } else {
        this.fetchActiveAlerts();
      }
    },
    
    
    clearAllMarkers() {
      if (this.unitMarkers && this.unitMarkers.length > 0) {
        this.unitMarkers.forEach(obj => obj.marker.setMap(null));
      }
      if (this.alertMarkers && this.alertMarkers.length > 0) {
        this.alertMarkers.forEach(obj => obj.marker.setMap(null));
      }
      this.unitMarkers = [];
      this.alertMarkers = [];
    },
    syncMapMarkersVisibility() {
      if (!this.map) return;

      const selectedUnitIds = new Set((this.selectedUnits || []).map(unit => String(unit.id)));
      const visibleAlertIds = new Set(this.visibleMapAlerts.map(alert => String(alert.id || alert.doc_id)));
      const visibleUnitIdsFromAlerts = new Set(this.visibleMapAlerts.map(alert => String(alert.id_unit)));

      this.unitMarkers.forEach(({ id, marker }) => {
        const shouldShowUnit =
          this.selectedFilters.length > 0
            ? visibleUnitIdsFromAlerts.has(String(id))
            : selectedUnitIds.size === 0 || selectedUnitIds.has(String(id));

        marker.setMap(shouldShowUnit ? this.map : null);
      });

      this.alertMarkers.forEach(({ id, marker }) => {
        marker.setMap(visibleAlertIds.has(String(id)) ? this.map : null);
      });
    },
    
    updateMarkersForSelectedUnits() {
      this.closeAllTooltips();

      //  Verifica PRIMEIRO, age depois — sem remoção prévia incondicional
      if (!this.selectedUnits || this.selectedUnits.length === 0) {
        this.syncMapMarkersVisibility();
        return;
      }

      this.syncMapMarkersVisibility();
    },
    createLocationIconSVG(color) {
      let size = 24
      return `<svg width="${size}" height="${size}" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0.5C9.98639 0.5 11.7287 1.19153 13.248 2.59277C14.7387 3.96754 15.5 5.8179 15.5 8.2002C15.4999 9.73317 14.8901 11.4487 13.5986 13.3574C12.3611 15.1865 10.4997 17.1802 8 19.3398C5.50027 17.1802 3.63889 15.1865 2.40137 13.3574C1.10992 11.4487 0.500052 9.73317 0.5 8.2002C0.5 5.8179 1.26133 3.96754 2.75195 2.59277C4.27134 1.19153 6.01361 0.5 8 0.5Z" fill="${color}" stroke="white"/>
      </svg>`;
    },

    labelContent(unit){
      return `
        <h4 class="marker-title">${unit.name}</h4>
        <br>
        <p><strong>Cliente:</strong> ${unit.name_client ?? 'Indefinido'}</p>
        <p><strong>Franqueado:</strong> ${unit.franchiseeName ?? 'Indefinido'}</p>
        <p><strong>Matrícula:</strong> ${unit.matricula ?? 'Indefinido '}</p>
      `
    },
    attachMarkerTooltip(marker, unit) {
      let hoverTimeout = null;
      let openedByClick = false;

      // Tooltip HTML via InfoWindow
      const infoWindow = new google.maps.InfoWindow({
        content: this.labelContent(unit),
        disableAutoPan: true
      });

      marker.__infoWindow = infoWindow;
      marker.__openedByClick = () => openedByClick;
      marker.__setOpenedByClick = (v) => openedByClick = v;
      // HOVER COM DELAY
      marker.content.addEventListener("mouseenter", () => {
        hoverTimeout = setTimeout(() => {
          if (!openedByClick) {
            infoWindow.open({
              anchor: marker,
              map: this.map
            });
          }
        }, 200);
      });

      marker.content.addEventListener("mouseleave", () => {
        clearTimeout(hoverTimeout);
        if (!openedByClick) infoWindow.close();
      });

      // CLIQUE: FIXAR / DESFIXAR
      marker.addListener("click", async () => {
        clearTimeout(hoverTimeout);

        openedByClick = !openedByClick;

        if (openedByClick) {
          infoWindow.open({
            anchor: marker,
            map: this.map
          });
        } else {
          infoWindow.close();
        }

        if (this.selectedUnits.length === 1 && this.selectedUnits[0].id === unit.id) {
          this.selectedUnits = [];
          this.$store.commit('SET_SELECTED_UNITS', []);
          this.$store.commit('SET_SELECTED_UNIT', null);
          await this.fetchMarks();
        } else {
          this.selectedUnits = [unit];
          this.$store.commit('SET_SELECTED_UNITS', [unit]);
          this.updateMarkersForSelectedUnits();
          this.newCenterMapOnSelectedUnit(unit);
        }
      });
    },
    createMarkerElement(color) {
      const markerElement = document.createElement('div');
      markerElement.className = 'custom-marker';
      markerElement.innerHTML = `
        <div class="custom-marker-container">     
          <div class="custom-marker-icon">
            ${this.createLocationIconSVG(color)}
          </div>
        </div>
      `;

      return markerElement;
    },
    
    createAlertElement(color) {
      //custom-alert-icon remove in class on line 642
      const markerElement = document.createElement('div');
      markerElement.className = 'custom-marker';
      markerElement.innerHTML = `
        <div class="custom-marker-container">
          <div class="custom-marker-icon">
            ${this.createLocationIconSVG(color)}
          </div>
        </div>
      `;

    
      return markerElement;
    },
    formatDate(date) {
      if (!date) return '';
      // Firestore Timestamp : Timestamp(seconds=..., nanoseconds=...)
      if (typeof date === 'object' && date.seconds !== undefined) {
        return new Date(date.seconds * 1000).toLocaleString();
      }
      // Firestore _seconds : { _seconds, _nanoseconds }
      if (typeof date === 'object' && date._seconds !== undefined) {
        return new Date(date._seconds * 1000).toLocaleString();
      }
      try {
        return new Date(date).toLocaleString();
      } catch {
        return String(date);
      }
    },
    async getGoalForUnits(units) {
      if (!units || units.length === 0) {
        return [];
      }
      
      try {
        //const response = await AlertsNotificationsService.findGoalByUnits(units);
        return [];
      } catch (error) {
        console.error('Erro ao buscar goals das unidades:', error);
        return [];
      }
    },
    
    getColorByGoalPercentage(goalPercentage) {
      let colorMarker = '#1D8AFF';
      
      if (goalPercentage === null || goalPercentage === undefined || goalPercentage === Infinity || isNaN(goalPercentage)) {
        return colorMarker;
      }
      
      if (goalPercentage < 0.7) {
        colorMarker = '#1D8AFF'; 
      } else if (goalPercentage >= 0.7 && goalPercentage <= 1) {
        colorMarker = '#FFB921'; 
      } else if (goalPercentage > 1) {
        colorMarker = '#FB2A2A'; 
      }
      
      return colorMarker;
    },
    toggleFilter(option) {
      const index = this.selectedFilters.indexOf(option);
      if (index > -1) {
        this.selectedFilters.splice(index, 1);
        if (this.selectedFilters.length === 0) {
          this.hasShownMarkerColorNotice = false;
        }
      } else {
        this.selectedFilters.push(option);
        if (!this.hasShownMarkerColorNotice) {
          showInfoSnackBar('A cor do pino no mapa refere-se ao alerta mais recente da unidade.');
          this.hasShownMarkerColorNotice = true;
        }
      }
    },
    toggleFilterSection() {
      this.showFilterSection = !this.showFilterSection;
    },
    getAlertBackgroundColor(alertType) {
      switch (alertType) {
        case "consumption":
          return "#FF9800"; 
        case "lack_of_signal":
          return "#F44336"; 
        case "no_variation":
          return "#4CAF50"; 
        case "low_battery":
          return "#9C27B0"; 
        case "no_communication":
          return "#2196F3"; 
        case "goal_scheduled":
          return "#FFC107"; 
        case "goal_exceeded":
          return "#D32F2F"; 
        case "water_probe_base_minimum_level":
          return "#8D6F64";
        case "water_probe_base_maximum_level":
          return "#EFC3CA";
        case "water_probe_sensor_error":
          return "#460202";
        default:
          return "#757575"; 
      }
    },
    openArchiveDialog(alert) {
      this.alertToArchive = alert;
      this.archiveObservationText = null;
      this.archiveObservationDialog = true;
    },
    openArchiveDialogByArchiveAll(alert) {
      this.alertToArchive = alert;
      this.archiveObservationText = null;
      this.archiveDialog = true;
    },
    confirmArchiveObservation() {
      this.archiveObservationDialog = false;
      this.archiveDialog = true;
    },
    async confirmArchive() {
      this.archiveDialog = false;
      if (this.alertToArchive && this.alertToArchive.length > 0) {
        try {
          this.alerts = this.alerts.filter(
            alert => !this.alertToArchive.some(a => a.id === alert.id)
          );
          this.alertToArchive.forEach(alert => {
            const idx = this.alertMarkers.findIndex(obj => obj.id === alert.id);
            if (idx !== -1) {
              this.alertMarkers[idx].marker.setMap(null);
            }
          });

          this.showArchiveToast = true;
          if (this.archiveTimer) {
            clearTimeout(this.archiveTimer);
          }
          this.archiveTimer = setTimeout(() => {
            this.performRealArchive();
          }, 3000);
        } catch (error) {
          console.error('Erro ao confirmar arquivamento:', error);
        }
      }
    },
    async performRealArchive() {
      if (this.alertToArchive && this.alertToArchive.length > 0 && this.archiveTimer) {
        try {
          let returnUpdatedWithObservation;
          let returnUpdateAlerts;

          clearTimeout(this.archiveTimer);
          this.archiveTimer = null;

          const alertToArchiveIds = this.alertToArchive.map(alert => {
            return alert.id || alert.doc_id
          });

          // case with observation text
          if(this.archiveObservationText && this.archiveObservationText.trim() !== ""){
            const nameUser = this.getCurrentUserName;
            const data = { 
              view: true, 
              archivedInfos: { 
                nameUser: nameUser, 
                archivedDate: new Date(),
                observation: this.archiveObservationText,
              } 
            };

            returnUpdatedWithObservation = 
              await AlertsService.updateAlertArchiveWithObservation(alertToArchiveIds[0], data);
          } else {
            // case without observation
            returnUpdateAlerts = await AlertsService.updateAlerts(alertToArchiveIds);
          }
          this.alertToArchive.forEach(alert => {
            if (this.historicalAlerts.length === 0) {
              this.archivedAlerts.push(alert);
            } else {
              this.historicalAlerts.unshift(alert);
            }
            if (this.selectedAlert && this.selectedAlert.id === alert.id) {
              this.selectedAlert = null;
              this.dialog = false;
            }

            const idx = this.alertMarkers.findIndex(obj => obj.id === alert.id);
            if (idx !== -1) {
              this.alertMarkers[idx].marker.setMap(null);
              this.alertMarkers.splice(idx, 1);
            }
          });

          this.alertToArchive = [];
          this.showArchiveToast = false;
        } catch (error) {
          console.error('Erro ao arquivar alerta:', error);
        } finally {
          this.archiveObservationText = null;
        }
      }
    },
    undoArchive() {
      if (this.alertToArchive && this.alertToArchive.length > 0) {
        try {
          if (this.archiveTimer) {
            clearTimeout(this.archiveTimer);
            this.archiveTimer = null;
          }

          this.alerts.push(...this.alertToArchive);
          this.alertToArchive.forEach(alert => {
            const idx = this.alertMarkers.findIndex(obj => obj.id === alert.id);
            if (idx !== -1) {
              this.alertMarkers[idx].marker.setMap(this.map);
            }
          });

          this.alertToArchive = [];
          this.showArchiveToast = false;
        } catch (error) {
          console.error('Erro ao desfazer arquivamento:', error);
        }
      }
    },
    closeToast() {
      this.showArchiveToast = false;
      if (this.archiveTimer) {
        this.performRealArchive();
      }
    },
    toggleAlertDetails(alertId) {
      const index = this.openAlertDetails.indexOf(alertId);
      if (index > -1) {
        this.openAlertDetails.splice(index, 1);
      } else {
        this.openAlertDetails.push(alertId);
      }
    },
    isAlertDetailsOpen(alertId) {
      const isOpen = this.openAlertDetails.includes(alertId);
      return isOpen;
    },

    async fetchActiveAlerts() {
      const selectedUnitIds = !this.selectedUnits || this.selectedUnits.length === 0
        ? []
        : this.selectedUnits.map(unit => unit.id);

      const filters = {
        date: this.getDateFilterForAlerts(),
        units: selectedUnitIds,
        types: this.selectedFilters.map(filter => this.changeAlertType(filter))
      };

      this.loadingActive = true;
      try {
        const response = await AlertsNotificationsService.mapFindAll(filters);
        const data = Array.isArray(response.data) ? response.data : [];

        // Se a API devolver unidades com `alerts`, achata e enriquece com nome da unidade e endereço
        let alerts = [];
        if (data.length > 0 && data[0].alerts) {
          alerts = data.flatMap(unit =>
            (unit.alerts || []).map(alert => ({
              ...alert,
              id_unit: unit.id,
              unitName: unit.name || '',
              address: unit.address || (unit.position && unit.position.address) || ''
            }))
          );
        } else {
          // Lista plana: enriquecer com this.units quando existir id_unit
          alerts = data.map(alert => {
            const unit = this.units.find(u => u.id === alert.id_unit);
            return {
              ...alert,
              unitName: alert.unitName || (unit ? unit.name : ''),
              address: alert.address || (unit && (unit.address || (unit.position && unit.position.address))) || ''
            };
          });
        }

        this.alerts = alerts.sort((a, b) => {
          const da = a?.date_of_occurrence?._seconds || 0;
          const db = b?.date_of_occurrence?._seconds || 0;
          return db - da;
        });
      } catch (error) {
        console.error('Erro ao buscar alertas ativos:', error);
        this.alerts = [];
      } finally {
        this.loadingActive = false;
        this.syncMapMarkersVisibility();
      }
    },

    async fetchHistoricalAlerts() {
      this.loadingHistorical = true
      this.historicalAlerts = [];
      try {
        const selectedType = this.selectedFilters.map(type => this.changeAlertType(type))
        const filters = (this.getSelectedUnits.length < 10)
          ?{date:this.getDateFilterForAlerts(),units:this.getSelectedUnits.map(u => u.id),types:selectedType}
          :{date:this.getDateFilterForAlerts(),units:[],types:selectedType}
        const response = await AlertsNotificationsService.mapFindHistorical(filters);
        let allAlerts = [];
        if (response.data && Array.isArray(response.data)) {
          response.data.forEach(unit => {
            if (unit.alerts && Array.isArray(unit.alerts)) {
              const alertsWithUnitInfo = unit.alerts.map(alert => ({
                ...alert,
                id_unit: unit.id,
                unitName: unit.name
              }));
              allAlerts = allAlerts.concat(alertsWithUnitInfo);
            }
          });
        }
        if (this.selectedUnit) {
          allAlerts = allAlerts.filter(alert => alert.id_unit === this.selectedUnit.id);
        }
        if(this.archivedAlerts.length > 0){
          this.archivedAlerts.forEach(alert => {
            this.historicalAlerts.unshift(alert)
          });
          this.archivedAlerts = [];
        }
        // Adiciona alertas da API apenas se não existirem duplicatas
        allAlerts.forEach(alert =>{
          const isDuplicate = this.historicalAlerts.some(existing => 
            existing.id === alert.id || existing.doc_id === alert.doc_id
          );
          if (!isDuplicate) {
            this.historicalAlerts.push(alert);
          }
        })
      } catch (error) {
        this.historicalAlerts = [];
        console.error('Erro ao buscar alertas históricos:', error);
      }finally {
        this.loadingHistorical = false
        this.syncMapMarkersVisibility();
      }
    },

    newCenterMapOnSelectedUnit(selectedUnit) {
      if(this.map && selectedUnit){
        const entry = this.unitMarkers.find(u => u.id === selectedUnit.id);
        if (entry && entry.marker && entry.marker.position) {
          const position = entry.marker.position;
          const newCenter = {
            lat: typeof position.lat === 'function' ? position.lat() : position.lat,
            lng: typeof position.lng === 'function' ? position.lng() : position.lng
          };
        this.map.panTo(newCenter);
        this.map.setZoom(14);
        }
      }
    },
    applyUnitFiltering() {
      if (this.getSelectedUnits && Array.isArray(this.getSelectedUnits) && this.getSelectedUnits.length > 0) {
        this.selectedUnits = this.getSelectedUnits;
      }
      
      this.updateMarkersForSelectedUnits();
    }
  },
  watch: {
    getSelectedUnits: {
      async handler(newUnit) {
        if (!Array.isArray(newUnit)) {
          return;
        }

        // Quando não há nenhuma unidade selecionada (ex.: "Desselecionar todos" na RightSidebar),
        // exibe novamente todos os pontos no mapa e recarrega os alertas.
        if (newUnit.length === 0) {
          this.selectedUnits = [];
          this.updateMarkersForSelectedUnits();

          if (this.selectedTab === "historico") {
            this.fetchHistoricalAlerts();
          } else {
            this.fetchActiveAlerts();
          }

          await this.$nextTick();
          this.recenterMap();
          return;
        }

        if (newUnit.length < 10) {
          this.alerts = [];
          if ((newUnit && Array.isArray(newUnit) && newUnit.length > 0) || this.selectedUnits.length > newUnit.length) {
            this.selectedUnits = newUnit;
            this.updateMarkersForSelectedUnits();
            if (this.selectedTab == "historico") {
              this.fetchHistoricalAlerts();
            } else {
              this.fetchActiveAlerts();
            }
            if (newUnit && newUnit.length > 0) {
              this.newCenterMapOnSelectedUnit(newUnit[newUnit.length - 1]);
            }
          }
        } else {
          showInfoSnackBar('Coloque no máximo 10 unidade para o filtro de unidades poder funcionar')
        }
      }
    },
    async selectedTab(newVal) {
      this.alerts = [];
      if (newVal === 'historico') {
        this.fetchHistoricalAlerts();
      }else{
        // buscar alertas ativos pelo periodo selecionado se alguma unidade estiver selecionada
        if(this.selectedUnits.length > 0){
          this.fetchActiveAlerts();
        }else{
          this.fetchActiveAlerts();
        }
      }
    },
    unitMeasureVuex() {
      this.formatNumberMeasure()
    },
    selectedPeriodValueVuex(newVal){
      if (newVal?.period === 'estimed' && this.getSelectedUnits?.length > 1) {
        showInfoSnackBar('No período estimado é permitida apenas uma unidade. A seleção foi ajustada.');
        this.$store.commit('SET_SELECTED_UNITS', [this.getSelectedUnits[0]]);
        this.selectedUnits = [this.getSelectedUnits[0]];
      }
      if (this.selectedTab === "historico") {
        this.fetchHistoricalAlerts();
      } else {
        this.fetchActiveAlerts();
      }
    },
    selectedFilters(){
      this.syncMapMarkersVisibility();
      if(this.selectedTab == "historico"){
        this.fetchHistoricalAlerts();
      }
    }
  },

  async created(){
    const sectors = await SectorsService.getSectors();
    sectors.forEach(sector => {
      this.sectorsByModem.set(sector.id_modem, sector);
    });
  },

  async mounted() {
    await this.initMap();
  },

  beforeDestroy() {
    // Limpa o timer se o componente for destruído
    if (this.archiveTimer) {
      clearTimeout(this.archiveTimer);
    }
  }
};
</script>

<style>
.kpi-btn.active {
  transform: scale(1.12);

  /* Glow suave com a cor do botão */
  box-shadow:
    0 0 0 3px rgba(255, 255, 255, 0.9),
    0 6px 16px rgba(0, 0, 0, 0.35);

  border: 2px solid white;

  filter: brightness(1.1);
}
.kpi-tooltip {
  background: linear-gradient(135deg, #ffffff, #f1f1f1) !important;
  color: #202020 !important;

  border-radius: 8px;
  padding: 6px 10px;
  font-size: 12px;
  font-weight: 500;

  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}
.map-kpi-wrapper {
  position: absolute;
  bottom: 300px;
  right: 12px;
  z-index: 100;

  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;

  
  border-radius: 20px;
}

/* Base */
.kpi-btn {
  font-weight: 600;
  font-size: 13px;
  color: #fff !important;

  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.25) !important;
  transition: all 0.2s ease;

  border: 2px solid rgba(255, 255, 255, 0.6);
}

/* Hover */
.kpi-btn:hover {
  transform: scale(1.08);
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.35) !important;
}

/* Total (destaque) */
.kpi-btn.total {
  background: linear-gradient(135deg, #ffffff, #f1f1f1) !important;
  color: #333 !important;

  border: 2px solid rgba(0, 0, 0, 0.1);
}

/* Opcional: efeito de clique */
.kpi-btn:active {
  transform: scale(0.95);
}
.alert-list {
  margin-top: 20px;
}
.gm-ui-hover-effect {
  display: none !important;
}
.custom-marker-icon {
  width: 24px;
  height: 24px;
}

.custom-marker-container {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px; /* igual ao ícone */
  height: 30px; /* só o tamanho do ícone */
}

.custom-alert-icon {
  position: absolute;
  bottom: 100%;
  border-radius: 8px;
  border: 4px solid white;
  background-color: white;
  width: 24px;
  height: 24px;
  background: url('./alert-icon.png') no-repeat center center;
  background-size: contain;
  animation: bounce 1.5s infinite;
}

.custom-marker-label {
  position: absolute;
  top: 110%; /* fica embaixo do ícone */
  left: 50%;
  transform: translateX(-50%);
  background-color: #ffffff;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  opacity: 0%;
  transition: opacity 0.3s ease, transform 0.3s ease;
  pointer-events: none;
  width: 220px;
  font-size: 13px;
  line-height: 1.4;
  z-index: 999999 !important;
  box-shadow: 0 2px 6px rgba(0,0,0,0.15);
}

.custom-marker-label h4.marker-title {
  margin: 0 0 6px;
  font-size: 14px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 4px;
}
.custom-marker-label p {
  margin: 4px 0;
}
.custom-marker-label .valor {
  color: #0077cc;
  font-weight: bold;
}

.custom-marker-label.show {
  opacity: 100%;
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-10px);
  }
  60% {
    transform: translateY(-5px);
  }
}

.close-alerts {
  display: inline-block;
  vertical-align: middle;
  width: 24px;
  height: 24px;
  transition: transform 0.2s;
}

.close-alerts:hover{
  background-color: #f5f5f5;;
}

.close-alerts.flipped {
  transform: scaleY(-1);
}

.open-alerts-details{
  display: inline-block;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  transition: transform 0.2s;
  rotate: 180deg;
}

.open-alerts-details:hover{
  background-color: #f5f5f5;;
}

.open-alerts-details.flipped {
  transform: scaleY(-1);
}

.filter-tag {
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  padding: 6px 12px;
  font-size: 0.875rem;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;
}

.filter-tag:hover {
  background-color: #e8f4fd;
  border-color: #1D8AFF;
  color: #1D8AFF;
}

.filter-tag.active {
  background-color: #e8f4fd;
  border-color: #1D8AFF;
  color: #1D8AFF;
}

.filter-tag.active .remove-icon {
  color: #1D8AFF;
}

.remove-icon {
  margin-left: 6px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  transition: color 0.2s ease;
  line-height: 1;
}

.remove-icon:hover {
  color: #ff4444;
}

.filter-header {
  transition: all 0.2s ease;
}

.filter-header:hover {
  opacity: 0.8;
}

.filter-header.active {
  font-weight: 600;
}

.archive-button {
  display: flex;
  justify-content: center; 
  border: 1px solid #DBDBDB;
  border-radius: 6px;
  padding: 10px; 
  cursor: pointer; 
  transition: all 0.2s ease;
  margin-top: 16px;
}
.archive-button:hover {
  background-color: #f5f5f5;
  border-color: #1D8AFF;
  color: #1D8AFF;
}

.archive-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  background-color: #f0f8ff;
  border-radius: 50%;
  margin: 0 auto;
}

.custom-toast {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 100;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid #e0e0e0;
  background-color: #ffffff;
  color: #333;
  font-size: 1rem;
  font-weight: 500;
  padding: 12px 20px;
  max-width: 400px;
  width: 90%;
  animation: slideIn 0.3s ease-out;
}

.toast-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

@keyframes slideIn {
  from {
    transform: translateX(-50%) translateY(100px);
    opacity: 0;
  }
  to {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
}

.success-icon-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: #1D8AFF;
  border-radius: 50%;
}

.tab-selector {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #efefef;
  border-radius: 6px;
  padding: 4px;
  margin: 0 16px 16px 16px;
  height: 5vh;
}

.tab-selector button {
  border: none;
  background: transparent;
  width: 50%;
  color: #aaa;
  font-weight: 600;
  font-size: 12px;
  padding: 8px;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.2s, color 0.2s;
}

.tab-selector button.active-tab {
  background: #fff;
  color: #333;
  box-shadow: 0 1px 4px rgba(0,0,0,0.03);
}

.alert-details-card {
  width: 100%;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 12px;
  padding: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  margin-bottom: 32px;
}

.details-content {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  line-height: 1.4;
}

.detail-label {
  font-size: 14px;
  color: #666;
  font-weight: 400;
}

.detail-value {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.detail-divider {
  height: 1px;
  background-color: #e0e0e0;
  margin: 8px 0;
}

.center-map-btn {
  border-radius: 999px !important;
  border: 1px solid #1D8AFF !important;
  background-color: #FFFFFF !important;
  box-shadow: none !important;
  width: 32px !important;
  height: 32px !important;
}

.center-map-btn--active {
  background-color: #1D8AFF !important;
  box-shadow: 0 0 0 1px rgba(29, 138, 255, 0.4) !important;
}
</style>
